import { ReactComponent as MetaLogo } from "images/meta-logo.svg";
import AuthButton from "../AuthButton";
import classNames from "classnames";
import "./style.css";

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
}

export default function MetaButton({ children, className, onClick }: Props) {
  return (
    <AuthButton
      buttonClass={classNames("meta-button", className)}
      imageClass="meta-logo"
      textClass="meta-text"
      logo={MetaLogo}
      onClick={onClick}
    >
      {children}
    </AuthButton>
  );
}
